<div class="body" [formGroup]="formArray">

    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">{{data.icon? data.icon: 'warning'}}</mat-icon>
        <span>
            {{data.title? data.title: 'Bestätigen'}}
        </span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <div class="note-wrapper">

            <div class="note-hint">
                {{data.text? data.text: 'Bitte geben Sie den folgenden Code ein um zu bestätigen: ' + data.doubleCheckValue}}
            </div>

        </div>

        <div class="check-code-row">

            <input 
                *ngFor="let entry of formArray.controls|keyvalue" 
                type="text" class="box-input" 
                [class.error]="invalidValue" 
                [value]="entry.value.value"
                (keydown)="jumpToNext($event, entry.key)" 
                #input />

        </div>

    </div>

    <div class="footer">

        <button mat-raised-button (click)="abort()">
            Abbrechen
        </button>

        <button mat-raised-button color="primary" (click)="confirm()">
            Abschließen
        </button>

    </div>

</div>